export default "__VITE_ASSET___MtMuqOB__"